import React from 'react'
import styled from 'styled-components'
import { Modal, ModalContentPadding } from './Modal'
import { ModalType } from '../../states/modals/ModalType.constants'
import { useAppSelector } from '../../hooks/useAppSelector'
import { Spinner } from '../Spinner/Spinner'
import { STYLES } from '../../static/style'

interface ILoadingModalProps {}

const ModalContent = styled.div``

const LoadingText = styled.div`
  text-align: center;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  font-size: ${STYLES.FONT_SIZE_XL};
`

const StyledSpinner = styled(Spinner)`
  transform: translateX(-2rem);
`

const LoadingIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const LoadingModal: React.FC<ILoadingModalProps> = () => {
  const { modalType } = useAppSelector(({ modals }) => modals)

  if (modalType !== ModalType.LOADING) {
    return null
  }
  return (
    <Modal isCenter contentPadding={ModalContentPadding.LG}>
      <ModalContent>
        <LoadingIconContainer>
          <StyledSpinner />
        </LoadingIconContainer>
        <LoadingText>Loading... Please wait</LoadingText>
      </ModalContent>
    </Modal>
  )
}

export default LoadingModal
